/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Imageviewer_Footer_Help_SmallInputs */



/**
* | output |
* | --- |
* | "+/- zoom • R rotate • Drag to pan • Ctrl+Scroll zoom" |
*
* @param {Spaces_Imageviewer_Footer_Help_SmallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_imageviewer_footer_help_small = /** @type {((inputs?: Spaces_Imageviewer_Footer_Help_SmallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Imageviewer_Footer_Help_SmallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("+/- Zoom • R drehen • Ziehen zum Verschieben • Strg+Scroll Zoom")
	return /** @type {LocalizedString} */ ("+/- zoom • R rotate • Drag to pan • Ctrl+Scroll zoom")
});